import styled from "@emotion/styled";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

export const ScheduleRow = styled(TableRow)({
  height: "48px",
  boxSizing: "border-box",
  "&:last-child td, &:last-child th": {
    borderBottom: 0,
  },
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
});

export const ScheduleCell = styled(TableCell)<{
  width?: string;
  textTransform?: "capitalize" | "none";
}>(({ width, textTransform }) => ({
  height: "48px",
  padding: "0 12px",
  verticalAlign: "middle",
  boxSizing: "border-box",
  ...(width ? { width } : {}),
  ...(textTransform ? { textTransform } : {}),
  "&:first-of-type": {
    paddingLeft: "24px",
  },
  "&:last-of-type": {
    paddingRight: "16px",
  },
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
}));

export const EmptyRowCell = styled(TableCell)({
  height: "48px",
  padding: "0 24px",
  verticalAlign: "middle",
  textAlign: "left",
  boxSizing: "border-box",
});
